export const FETCH_START = "FETCH_START";
export const FETCH_STOP = "FETCH_STOP";
export const FETCH_SUCCESS = "FETCH_SUCCESS";
export const FETCH_START_WITH_FORWARD = "FETCH_START_WITH_FORWARD";
